/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for Permission controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetPermissionCatalogResponse, GetPermissionAssignmentsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class PermissionService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getPermissionCatalog(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPermissionCatalogResponse>;
    getPermissionCatalog(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPermissionCatalogResponse>>;
    getPermissionCatalog(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPermissionCatalogResponse>>;
    getPermissionCatalog(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Permission`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    getPermissionAssignments(observe?: 'body', options?: RequestOptions<'json'>): Observable<GetPermissionAssignmentsResponse>;
    getPermissionAssignments(observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetPermissionAssignmentsResponse>>;
    getPermissionAssignments(observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetPermissionAssignmentsResponse>>;
    getPermissionAssignments(observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/Permission/assignments`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }
}
